import { Component, OnDestroy } from '@angular/core';
import {
  ResultAttribute,
  UserPreferencesState,
  UserPreferencesStateKey
} from '@approot/models';
import { ProductsConfigService, UserStorageService } from '@approot/services';
import { Subscription } from 'rxjs';
import { LegService } from '@approot/services/leg/leg.service';
@Component({
  selector: 'app-dcd-results-attributes',
  templateUrl: './dcd-results-attributes.component.html',
  styleUrls: ['./dcd-results-attributes.component.scss']
})
export class DcdResultsAttributesComponent implements OnDestroy {
  public dcdSpecifications: ResultAttribute[];
  public activeDcdAttributes: any[];
  private sub: Subscription;

  constructor(
    private legService: LegService,
    private productsConfigService: ProductsConfigService,
    private userStorageService: UserStorageService
  ) {
    this.sub = this.userStorageService
      .storeChangesObservable<UserPreferencesState>(UserPreferencesStateKey)
      .subscribe(prefs => {
        this.dcdSpecifications =
          this.productsConfigService.pricingResultsInfo.dcdSpecifications;

        const displayAttributes = prefs.PricingDisplayPrefs;
        this.activeDcdAttributes = this.legService.activeDcdAttributes.filter(
          r => (displayAttributes[r.shortName] ?? true) || !!r.header
        );
      });
  }

  public ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  get dcdResultsExpanded() {
    return this.legService.dcdResultsExpanded;
  }

  set dcdResultsExpanded(val) {
    this.legService.dcdResultsExpanded = val;
  }
}
